export interface IDispose {
  dispose: () => Promise<void>;
}

export async function disposeOf(disposable?: IDispose | null) {
  await disposable?.dispose();
}
